// extracted by mini-css-extract-plugin
export default {"detalle":"PopupGol_detalle__p2u+9"};